import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useHistory, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getAllUsers, getFeatureToggle, updateFeatureToggle } from '../../../services/featureTogglesSlice';

import Container from './container';
import { RootState } from '../../../app/store';

const EditFeatureToggle = ({}:any) => {
    
    const { featureToggleId } = useParams<any>();        

    const dispatch = useAppDispatch();    
    let history = useHistory();  

    useEffect(() => {
        dispatch(getFeatureToggle(featureToggleId))
        dispatch(getAllUsers());
    }, []);

    const selectAccount = (state: RootState) => state.featureToggles;
      const { 
        featureToggle,
        featureTogglesLoading,    
        error,
        users
      } = useAppSelector(selectAccount); 

    const onSave = (featureToggle: any) => {             
        dispatch(updateFeatureToggle({ featureToggle, id: +featureToggleId}))
         .then((response: any) => {
            if (response.payload.success) {
                history.push(`/admin/feature-toggles/list`)
            } else {
                
            }
           });
    };    

    
    return (
       <Container title="Edit Feature Toggle" 
                  featureToggle={featureToggle}
                  isLoading={featureTogglesLoading}
                  onSave={onSave}                  
                  error={error}
                  users={users} />
    )
};

export default EditFeatureToggle;